import { ZSpecCategoryOption } from "./ZSpecification";

// Пока решили с Ромой захардкодить этот справочник

export const specCategoryOptions: ZSpecCategoryOption[] = [
  { code: 0, label: "Без категории" },
  { code: 1, label: "Персональные данные" },
  { code: 2, label: "Коммерческая тайна" },
];
